<template>
  <section
    class="status-box status-box--pending"
    v-if="!transaction || transaction?.status === TRANSACTION_TYPE_PENDING"
  >
    <article class="">
      <h1>
        {{ $t("credits.success.title") }} {{ $t("credits.success.pending") }}
      </h1>
      <ContentLoader />
    </article>
  </section>

  <section
    class="status-box status-box--completed"
    v-else-if="transaction.status === TRANSACTION_TYPE_COMPLETED"
  >
    <article :class="glow ? 'is-active' : ''">
      <div class="success-checkmark">
        <svg
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 130.2 130.2"
        >
          <circle
            class="path circle"
            fill="none"
            stroke="#43ca85"
            stroke-width="6"
            stroke-miterlimit="10"
            cx="65.1"
            cy="65.1"
            r="62.1"
          />
          <polyline
            class="path check"
            fill="none"
            stroke="#43ca85"
            stroke-width="6"
            stroke-linecap="round"
            stroke-miterlimit="10"
            points="100.2,40.2 51.5,88.8 29.8,67.5 "
          />
        </svg>
      </div>

      <h1>
        {{ $t("credits.success.title") }} {{ $t("credits.success.completed") }}
      </h1>
      <p class="sub-heading">
        {{
          $t("credits.payment_success_subheading250", {
            credits: transaction.credits,
          })
        }}
      </p>

      <!-- <ul>
                <li>
                    <p>{{$t('credits.success.amount')}}:</p>
                    <span>{{Number(transaction.amount).toFixed(2)}}</span>
                </li>
                <li>
                    <p>{{$t('credits.success.currency')}}:</p>
                    <span>{{transaction.currency}}</span>
                </li>
                <li>
                    <p>{{$t('credits.success.credits')}}:</p>
                    <span>{{transaction.credits}}</span>
                </li>
            </ul> -->

      <ul class="info-box">
        <li>
          <p>{{ $t("credits.payment_status_amount_charged") }}:</p>
          <span
            ><strong>{{ Number(transaction.amount).toFixed(2) }}</strong></span
          >
        </li>
        <li>
          <p>{{ $t("credits.payment_status_currency") }}:</p>
          <span
            ><strong>{{ transaction.currency }}</strong></span
          >
        </li>
        <li>
          <p>{{ $t("credits.payment_status_credits_added") }}:</p>
          <span class="clr-gold"
            ><strong
              >{{ transaction.credits }} {{ $t("credits.credits") }}</strong
            ></span
          >
        </li>
        <li>
          <p>{{ $t("credits.payment_status_billing_reference") }}</p>
          <span
            ><strong>{{
              $t("credits.payment_status_billing_reference_value")
            }}</strong></span
          >
        </li>
      </ul>

      <div class="save-card" v-if="hasCard">
        <div class="checkbox">
          <input
            class="form-check-input"
            type="checkbox"
            @change="optIn($event)"
            id="saveCard"
            :checked="one_click_opt_in"
          />
          <label class="checkbox__label" for="saveCard">
            <div class="checkbox__icon">
              <svg width="16" viewBox="0 0 24 24" xml:space="preserve">
                <path
                  fill="#fff"
                  d="M10 18c-.5 0-1-.2-1.4-.6l-4-4c-.8-.8-.8-2 0-2.8.8-.8 2.1-.8 2.8 0l2.6 2.6 6.6-6.6c.8-.8 2-.8 2.8 0 .8.8.8 2 0 2.8l-8 8c-.4.4-.9.6-1.4.6z"
                ></path>
              </svg>
            </div>
          </label>
        </div>
        <div class="content">
          <h3>
            <strong>{{ $t("credits.save_card_title") }}</strong>
          </h3>
          <p>
            {{ $t("credits.save_card_text") }}
            <span class="clr-gold">{{
              $t("credits.save_card_data_link")
            }}</span>
          </p>
        </div>
      </div>

      <ul class="promotion-benefits">
        <li class="promotion-benefits__item">
          <span class="promotion-benefits__icon">
            <svg
              width="12"
              height="12"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
            >
              <rect x="3" y="11" width="18" height="11" rx="2"></rect>
              <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
            </svg>
          </span>
          <span>{{ $t("credits.security_ssl") }}</span>
        </li>
        <li class="promotion-benefits__item">
          <span class="promotion-benefits__icon">
            <svg
              width="12"
              height="12"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
            >
              <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
            </svg>
          </span>
          <span>{{ $t("credits.security_pci") }}</span>
        </li>
        <li class="promotion-benefits__item">
          <span class="promotion-benefits__icon">
            <svg
              width="12"
              height="12"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
            >
              <circle cx="12" cy="12" r="10"></circle>
              <line x1="12" y1="8" x2="12" y2="12"></line>
              <line x1="12" y1="16" x2="12.01" y2="16"></line>
            </svg>
          </span>
          <span>{{ $t("credits.security_card_data_never_stored") }}</span>
        </li>
        <li class="promotion-benefits__item">
          <span class="promotion-benefits__icon">
            <svg
              width="12"
              height="12"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
            >
              <rect x="1" y="4" width="22" height="16" rx="2"></rect>
              <line x1="1" y1="10" x2="23" y2="10"></line>
            </svg>
          </span>
          <span>{{ $t("credits.security_tokenised_provider") }}</span>
        </li>
      </ul>

      <slot name="success_action"></slot>

      <p class="footer-success-action">
        {{ $t("credits.save_card_footer_before_terms") }}
        <span class="clr-gold">{{ $t("credits.save_card_footer_terms") }}</span>
        {{ $t("credits.save_card_footer_after_terms") }}
        <span class="clr-gold">{{
          $t("credits.save_card_footer_account_settings")
        }}</span>
      </p>
    </article>
  </section>

  <section
    class="status-box status-box--failed"
    v-else-if="transaction.status === TRANSACTION_TYPE_FAILED"
  >
    <article :class="glow ? 'is-active' : ''">
      <div class="failed-checkmark">
        <svg
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 130.2 130.2"
        >
          <circle
            class="path circle"
            fill="none"
            stroke="#a82e2e"
            stroke-width="6"
            stroke-miterlimit="10"
            cx="65.1"
            cy="65.1"
            r="62.1"
          />
          <line
            class="path line"
            fill="none"
            stroke="#a82e2e"
            stroke-width="6"
            stroke-linecap="round"
            stroke-miterlimit="10"
            x1="34.4"
            y1="37.9"
            x2="95.8"
            y2="92.3"
          />
          <line
            class="path line"
            fill="none"
            stroke="#a82e2e"
            stroke-width="6"
            stroke-linecap="round"
            stroke-miterlimit="10"
            x1="95.8"
            y1="38"
            x2="34.4"
            y2="92.2"
          />
        </svg>
      </div>

      <h1>
        {{ $t("credits.success.title") }} {{ $t("credits.success.failed") }}
      </h1>

      <ul class="info-box">
        <li>
          <p>{{ $t("credits.success.amount") }}:</p>
          <span>{{ Number(transaction.amount).toFixed(2) }}</span>
        </li>
        <li>
          <p>{{ $t("credits.success.currency") }}:</p>
          <span>{{ transaction.currency }}</span>
        </li>
        <li>
          <p>{{ $t("credits.success.credits") }}:</p>
          <span>{{ transaction.credits }}</span>
        </li>
      </ul>
      <div>
        <slot name="failed_action"></slot>
      </div>
    </article>
  </section>
</template>

<script>
import ContentLoader from "@/components/ContentLoader.vue";
import {TRANSACTION_TYPE_COMPLETED, TRANSACTION_TYPE_FAILED, TRANSACTION_TYPE_PENDING} from "@/types/transactions";
import {mapActions, mapState} from "vuex";
import { updateOptIn } from "@/api/credits";
import toastr from "toastr";

export default {
    name: "PaymentStatus",
    components: {ContentLoader},
    props: {
        transaction: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            working: false,
            glow: false,
        }
    },
    computed: {
        ...mapState({
            one_click_opt_in: state => state.credits.one_click_opt_in,
            hasCard: state => state.credits.card
        })
    },
    methods: {
        ...mapActions({
            optInUpdate: 'credits/setOneClick'
        }),
        removeGlow() {
            setTimeout(() => this.glow = false, 1000);
        },
        async optIn(event) {

            try {
                const payload = await updateOptIn({one_click_opt_in: event.target.checked})
                await this.optInUpdate(payload.data.one_click_opt_in)
                toastr.success(this.$i18n.t('profile.edit.profile_changed'))
            } catch {
                toastr.error(this.$i18n.t('credits.error_processing'))
            }
        }
    },
    watch: {
        transaction: {
            handler() {
                this.glow = true
                this.removeGlow()
            },
            immediate: true
        }
    },
    created() {
        this.TRANSACTION_TYPE_COMPLETED = TRANSACTION_TYPE_COMPLETED
        this.TRANSACTION_TYPE_PENDING   = TRANSACTION_TYPE_PENDING
        this.TRANSACTION_TYPE_FAILED    = TRANSACTION_TYPE_FAILED
    }
}
</script>

<style scoped lang="scss">
.promotion-benefits {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  column-gap: 13px;
  row-gap: 8px;
  width: 100%;
  margin: 20px 0;
  list-style: none;
}

.promotion-benefits__item {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 10px;
  font-weight: 400;
  line-height: 1.3;
  white-space: nowrap;
  color: $color-credits-type3;
}

.promotion-benefits__icon {
  color: $color-credits-type3;
  font-size: 15px;
  font-weight: 700;
  line-height: 1;
}

@media (max-width: 420px) {
  .promotion-benefits {
    column-gap: 16px;
    padding-inline: 12px;
  }

  .promotion-benefits__item {
    font-size: 12px;
  }
}

.save-card {
  text-align: left;
  border-radius: 10px;
  padding: 20px;
  background-color: $color-credits-type6;
  color: $color-type19;
  border: 1px solid $color-type19;
  display: flex;
  gap: 0;
  margin-bottom: 20px;
  align-items: flex-start;

  h3 {
    color: $color-credits-type4;
    margin-top: 8px;
    margin-bottom: 10px;
  }

  p {
    color: $color-credits-type2;
    font-size: 14px;
    line-height: 1.3;
    margin-bottom: 0;
  }
}

.footer-success-action {
  font-size: 12px;
  line-height: 1.4;
  color: #7a4060;
  margin-bottom: 0;
  margin-top: 15px;
}

.status-box {
  padding: 50px 0;

  article {
    width: 100%;
    margin: 0 auto;
    max-width: 500px;
    text-align: center;
    padding: 50px 30px 30px;
    transition: all 0.6s ease-in-out;
    border-radius: 10px;
    background-color: $color-type1;
    border: 1px solid $color-credits-border;
  }

  h1 {
    font-weight: 700;
    font-size: 31px;
    line-height: 1.3;
    color: $color-credits-type4;
  }

  .sub-heading {
    font-size: 14px;
    line-height: 1.4;
    color: $color-credits-type3;
  }

  .info-box {
    margin-bottom: 20px;

    li {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 15px 0;

      &:not(:last-child) {
        border-bottom: 1px solid #dedede;
      }
    }

    p {
      margin-bottom: 0;
      font-size: 16px;
      color: rgb(119, 119, 119);
    }

    span {
      font-size: 16px;
      font-weight: 600;
      color: rgb(0, 0, 0);
    }
  }
}

.status-box--failed {
  article {
    &.is-active {
      box-shadow: 0 0 15px #a82e2e;
      border: 1px solid #a82e2e;
    }
  }
}

.status-box--completed {
  article {
    &.is-active {
      box-shadow: 0 0 15px #43ca85;
      border: 1px solid #43ca85;
    }
  }
}

.status-box--pending {
  article {
    border: none;
    box-shadow: none;
    background-color: transparent;

    h1 {
      margin-bottom: -150px;
    }
  }
}

.success-checkmark {
  svg {
    background-color: rgba(#43ca85, 0.2);
  }
}

.failed-checkmark {
  svg {
    background-color: rgba(#a82e2e, 0.2);
  }
}

.success-checkmark,
.failed-checkmark {
  margin: 0 auto 30px;
  text-align: center;

  svg {
    width: 80px;
    display: block;
    margin: 0 auto;
    border-radius: 50%;
  }
}

.pay-pal {
  margin-top: 20px;
  h2 {
    margin-bottom: 0;
    margin-right: 10px;
  }

  p {
    margin-top: 20px;
    font-size: 14px;
    line-height: 1.3;
  }
}

.path {
  stroke-dasharray: 1000;
  stroke-dashoffset: 0;
  &.circle {
    -webkit-animation: dash 1s ease-in-out;
    animation: dash 1s ease-in-out;
  }
  &.line {
    stroke-dashoffset: 1000;
    -webkit-animation: dash 1s 0.35s ease-in-out forwards;
    animation: dash 1s 0.35s ease-in-out forwards;
  }
  &.check {
    stroke-dashoffset: -100;
    -webkit-animation: dash-check 1s 0.35s ease-in-out forwards;
    animation: dash-check 1s 0.35s ease-in-out forwards;
  }
}

@-webkit-keyframes dash {
  0% {
    stroke-dashoffset: 1000;
  }
  100% {
    stroke-dashoffset: 0;
  }
}

@keyframes dash {
  0% {
    stroke-dashoffset: 1000;
  }
  100% {
    stroke-dashoffset: 0;
  }
}

@-webkit-keyframes dash-check {
  0% {
    stroke-dashoffset: -100;
  }
  100% {
    stroke-dashoffset: 900;
  }
}

@keyframes dash-check {
  0% {
    stroke-dashoffset: -100;
  }
  100% {
    stroke-dashoffset: 900;
  }
}
</style>
